import i18next from "i18next";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

import { cap } from "../../../utils/utils";

import LanguageDetector from "i18next-browser-languagedetector";

function InputTicketSubTypes({ type, name, value, onChange, required, error }) {
  const { t } = useTranslation();
  const { ticketSubTypes } = useSelector((state) => state.customerServiceReducer);

  const currentLanguage = i18next.use(LanguageDetector);

  return (
    <div className={`lineInput lineInput${type} lineInput${cap(name)} ${error ? "invalid" : ""}`}>
      <label htmlFor={name}>{t("SUBTYPE")}</label>
      {required && <span className={`${error ? "invalid" : ""}`}>{t("REQUIRED_FIELD")}</span>}
      <select name={name} value={value} onChange={(e) => onChange(e, name)}>
        <option value={""}> {t("SELECT")}</option>
        {ticketSubTypes?.map(
          (option) =>
            option.active === true && (
              <option
                key={
                  currentLanguage.language === "en"
                    ? option.nameEnglish
                    : currentLanguage.language === "pt"
                    ? option.namePortuguese
                    : option.nameSpanish
                }
                value={option.id}
              >
                {" "}
                {currentLanguage.language === "en"
                  ? option.nameEnglish
                  : currentLanguage.language === "pt"
                  ? option.namePortuguese
                  : option.nameSpanish}{" "}
              </option>
            ),
        )}
      </select>
    </div>
  );
}

export default InputTicketSubTypes;
